import ImageHeading from "../components/ui/ImageHeading";
import tuitionFeesImage from "../assets/header/header.jpeg";
import { motion } from "framer-motion";
import IQACMission from "../components/CenterOfExcellence/IQACMission";
import { CircleCheckBig } from "lucide-react";
import useAxiosPublic from "../hooks/useAxiosPublic";
import LoadingPage from "../components/Layout/LoadingPage";
import { useQuery } from "@tanstack/react-query";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
// const specialScholarshipsData = [
//   {
//     id: 1,
//     title: "Freedom Fighters",
//     description:
//       "The University pursues a policy of awarding up to 100% waiver of tuition fees to the children of freedom fighters of the Liberation War of Bangladesh, with provision for higher levels of award for those from modest economic backgrounds. In order to continue with this scholarship, a student requires to maintain a minimum CGPA of 3.25 in every semester.",
//   },
//   {
//     id: 2,
//     title: "Donor’s Scholarship",
//     description:
//       "If a donor provides a scholarship to any student, that scholarship will be governed by the policies adopted by the donor.",
//   },
//   {
//     id: 3,
//     title: "Sibling Scholarship",
//     description:
//       "If one sibling has been studying at ZUMS, other sibling(s) who enrolled later will be eligible to apply for a tuition waiver up to 30%. In order to continue with this scholarship, a student requires to maintain a minimum CGPA of 3.0 in every semester.",
//   },
//   {
//     id: 4,
//     title: "Female Students",
//     description:
//       "If a female student does not qualify for a scholarship under any other category, she is entitled to a 10% tuition fee waiver.",
//   },
//   {
//     id: 5,
//     title: "Graduate Students",
//     description:
//       "ZUMS makes financial assistance available to graduate students in various forms. These include scholarships, teaching and research assistantships, and on-campus employment. The above-mentioned Special Scholarships for undergraduate students are equally applicable for the graduate students at ZUMS. We make arrangements with organizations in both public and private sectors of Bangladesh for providing group tuition fee waiver to the prospective graduate students from those organizations.",
//   },
//   {
//     id: 6,
//     title:
//       "ZUMS Scholarship for Meritorious Students of Disadvantaged Families",
//     description:
//       "100% tuition fee waiver (excluding other fees) plus a stipend for defraying the cost of food and accommodation is awarded to selected meritorious students coming from economically disadvantaged families. In order to continue receiving this scholarship up to the end of the undergraduate program, a minimum CGPA of 3.5 on a scale of 4 is required to be maintained in all the semesters. If a student fails to maintain the required CGPA, she/he will receive tuition and other fees waiver for the subsequent two consecutive semesters during which she/he will need to regain the required CGPA, otherwise the scholarship will be discontinued.",
//   },
// ];

const Scholarship = () => {
  const axiosPublic = useAxiosPublic();

  const {
    data: scholarshipApiData,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["admissionScholarshipData"],
    queryFn: async () => {
      const res = await axiosPublic.get("/admission/admission-scholarship");
      return res?.data;
    },
  });

  if (isLoading) {
    return <LoadingPage />;
  }

  if (error) {
    return (
      <div className="text-center py-20 text-red-500">Error loading data</div>
    );
  }
  console.log(scholarshipApiData, "scholarship data");
  return (
    <div>
      <ImageHeading
        heading="Scholarships and Financial Aid "
        imageUrl={tuitionFeesImage}
      />

      <div className="container px-4 mx-auto md:px-8">
        <div className="mb-12 lg:mb-16 ">
          <h3 className="text-2xl font-bold text-black lg:text-4xl font-domine">
            {scholarshipApiData?.title}
          </h3>
          <div className="py-6 space-y-4 leading-loose text-gray-700 ">
            <ReactMarkdown rehypePlugins={[rehypeRaw]}>
              {scholarshipApiData?.description}
            </ReactMarkdown>
          </div>
          <div className="ml-5 lg:ml-8">
            <div className=" space-y-4">
              {scholarshipApiData?.points?.map((point, idx) => (
                <p key={idx} className="flex items-center gap-3">
                  <span>
                    <CircleCheckBig className="hidden lg:block size-5 text-primary" />
                  </span>
                  <span className="text-gray-700 ">{point?.title}</span>
                </p>
              ))}
            </div>
          </div>
        </div>
        {/* table */}
        <div className="max-w-3xl pb-5 mx-auto">
          <div className="pb-8 space-y-3">
            <motion.h2
              className="text-4xl font-bold text-center text-gray-800 font-domine"
              initial={{ opacity: 0, y: -50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
            >
              {scholarshipApiData?.scholarship_based_academic_result?.title}
            </motion.h2>
            <p className="max-w-3xl mx-auto text-sm text-center text-gray-600 md:text-base">
              {
                scholarshipApiData?.scholarship_based_academic_result
                  ?.description
              }
            </p>
          </div>
          <table className="min-w-full bg-white border border-gray-200 rounded-lg shadow-md">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-4 py-2 text-sm font-medium text-left text-gray-700">
                  CGPA
                </th>
                <th className="px-4 py-2 text-sm font-medium text-left text-gray-700">
                  Tuition Waiver (%)
                </th>
              </tr>
            </thead>
            <tbody>
              {scholarshipApiData?.scholarship_based_academic_result?.result_percentage?.map(
                (result, idx) => (
                  <tr key={idx} className="border-t border-gray-200">
                    <td className="px-4 py-5 text-sm text-gray-600">
                      {result?.result}
                    </td>
                    <td className="px-4 py-5 text-sm text-gray-600">
                      {result?.percentage}%
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
        <IQACMission
          title={scholarshipApiData?.special_scholarship?.title}
          details={" "}
          data={scholarshipApiData?.special_scholarship?.points}
        />
      </div>
    </div>
  );
};

export default Scholarship;
